import "./App.css";
import AppRouters from "./routers/AppRouters";

function App() {
  return <AppRouters  />;
}
// Firebase Database Name is = Product-Multimart

export default App;
